var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CCard',{attrs:{"border-color":"info"}},[_c('img',{attrs:{"src":(_vm.publicPath + "images/" + _vm.imagesrc),"height":"100px","width":"100px"}}),_c('span',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }